/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Specification - Omobility app
 * OpenAPI documentation for Omobility app with Keycloak user authentication
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { CarImageDto } from './car-image-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { Features } from './features';

/**
 * 
 * @export
 * @interface CarDto
 */
export interface CarDto {
    /**
     * 
     * @type {string}
     * @memberof CarDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarDto
     */
    'make'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarDto
     */
    'model'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarDto
     */
    'image'?: string;
    /**
     * 
     * @type {Features}
     * @memberof CarDto
     */
    'features'?: Features;
    /**
     * 
     * @type {number}
     * @memberof CarDto
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarDto
     */
    'discountAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarDto
     */
    'finalPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarDto
     */
    'buyingPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarDto
     */
    'vatRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarDto
     */
    'vatRegime'?: string;
    /**
     * 
     * @type {number}
     * @memberof CarDto
     */
    'vatAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarDto
     */
    'priceWithVat'?: number;
    /**
     * 
     * @type {number}
     * @memberof CarDto
     */
    'margin'?: number;
    /**
     * 
     * @type {string}
     * @memberof CarDto
     */
    'vin'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CarDto
     */
    'transmission'?: CarDtoTransmissionEnum;
    /**
     * 
     * @type {string}
     * @memberof CarDto
     */
    'status'?: CarDtoStatusEnum;
    /**
     * 
     * @type {Array<CarImageDto>}
     * @memberof CarDto
     */
    'images'?: Array<CarImageDto>;
    /**
     * 
     * @type {boolean}
     * @memberof CarDto
     */
    'favorite'?: boolean;
}

export const CarDtoTransmissionEnum = {
    Automatic: 'AUTOMATIC',
    Manual: 'MANUAL'
} as const;

export type CarDtoTransmissionEnum = typeof CarDtoTransmissionEnum[keyof typeof CarDtoTransmissionEnum];
export const CarDtoStatusEnum = {
    Available: 'AVAILABLE',
    Reserved: 'RESERVED',
    Sold: 'SOLD'
} as const;

export type CarDtoStatusEnum = typeof CarDtoStatusEnum[keyof typeof CarDtoStatusEnum];


